import Color from 'color'

export const LIGHT = '#ffffff'
export const DARK = '#000000'

export type MarkingPhotoColor = typeof LIGHT | typeof DARK

export const coerceColor = (color: string): MarkingPhotoColor => {
    if ([LIGHT, DARK].includes(color)) {
        return color as MarkingPhotoColor
    }
    return Color(color).grayscale().gray() >= 50 ? LIGHT : DARK
}
